import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Close } from '@carvana/icons';

export const Wrapper = styled.span`
  cursor: pointer;
  display: inline-block;
  position: relative;
`;

const arrowSize = 8;

export const Content = styled.span`
  background-color: ${props => props.theme.carvana.blue.dark};
  border-radius: 3px;
  color: white;
  font-size: 14px;
  height: 0;
  padding: 16px;
  position: absolute;
  opacity: 0;
  width: 0;
  z-index: 5;

  &.open {
    height: initial;
    min-width: 240px;
    opacity: 1;
    transition: opacity .2s ease-in .25s;
    width: initial;
  }

  &::before {
    border-bottom: ${arrowSize}px solid ${props => props.theme.carvana.blue.dark};
    border-left: ${arrowSize}px solid transparent;
    border-right: ${arrowSize}px solid transparent;
    content: '';
    height: 0; 
    left: calc(50% - ${arrowSize / 2}px);
    position: absolute;
    top: -${arrowSize}px;
    width: 0; 
  }
`;

export const CloseIcon = styled(Close)`
  position: absolute;
  right: 16px;
  top: 16px;

  & > svg {
    height: 14px;
    width: 14px;
  }
`;

const Tooltip = ({ children, content, hover, onClose, onOpen }) => {
  const contentRef = useRef();
  const [isOpen, setIsOpen] = useState();

  useEffect(() => {
    const { clientHeight: ht, clientWidth: wd } = contentRef.current;

    contentRef.current.style.bottom = `-${ht + 8}px`;
    contentRef.current.style.left = `calc(50% - ${wd / 2}px)`;

    if (typeof isOpen === 'boolean') {
      isOpen ? (onOpen && onOpen()) : (onClose && onClose());
    }
  }, [isOpen]);

  return (
    <Wrapper
      onClick={() => !hover && setIsOpen(!isOpen)}
      onMouseEnter={() => hover && setIsOpen(true)}
      onMouseLeave={() => hover && setIsOpen(false)}
    >
      {children}
      <Content className={isOpen && 'open'} ref={contentRef}>
        {!hover && <CloseIcon onClick={() => setIsOpen(false)} />}       
        {isOpen && content}
      </Content>
    </Wrapper>
  );
};

Tooltip.propsTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  hover: PropTypes.boolean,
  onClose: PropTypes.function,
  onOpen: PropTypes.function
};

Tooltip.defaultProps = {
  content: '',
  hover: false,
  onClose: null,
  onOpen: null
};

export default Tooltip;